import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export type SupplierTabValue = 'suppliers' | 'producers';

export const DistributorsListSerachParamsSchema = createSortSchema(['name', 'town', 'county'] as const, {
  defaultSortBy: 'name',
  defaultSortOrder: 'asc',
})
  .concat(
    createPaginationSchema({
      defaultPage: 1,
      defaultPageSize: 25,
      allowedPageSizes: [25, 50, 100],
    })
  )
  .concat(
    Yup.object({
      tab: Yup.mixed<SupplierTabValue>()
        .oneOf(['suppliers', 'producers'] as const)
        .optional()
        .default('suppliers'),
    })
  );
